import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as reviewsActions from '../../actions/reviewsActionCreators';
import {withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import {NavLink} from 'react-router-dom';
import {useMount} from 'react-use';
import SeoTags from '../../routes/SeoTags';
import constants from '../../constants';
import PartnersList from '../../components/Partners/List';

const PartnersPage = (props) => {
  const
    {partners_collection} = props.reviewsState;

  useMount(() => {
    props.reviewsActions.fetchPartnersReviews();
  });

  return (
    <Layout
      className='reviews-page'
      breadcrumbs={[
        {label: 'Партнёры'}
      ]}
    >
      <SeoTags
        controller_action='partners#index'
      />

      <div className='container'>
        <div className='reviews-page__navigation'>
          <NavLink className='link' to={constants.ROUTES.REVIEWS_PATH}>Отзывы</NavLink>
          <NavLink className='link' to={constants.ROUTES.PARTNERS_PATH}>Партнёры</NavLink>
        </div>
        <div className='reviews-page__container'>
          <PartnersList collection={partners_collection} />
        </div>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      reviewsActions: bindActionCreators(reviewsActions, dispatch)
    };
  },

  mapStateToProps = ({reviewsState, railsContext, applicationState}) => {
    return {
      applicationState,
      reviewsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(PartnersPage));
